<template>
<div class="choiceVideoImage form dialog-form">
    <el-dialog :title="uploadType.datatype == 'IMAGE' ? '选择图片' : '选择视频'" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogFormVisible" custom-class="dialogForm" class="scrollBoxDialog measDialog" width="770px">
        <scroll :uploadType="uploadType" @saveFile="_saveFile" ref="scroll"></scroll>
        <div slot="footer" class="dialog-footer" v-if="!hideBtn">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Scroll from './scroll.vue'
export default {
    name: 'scrollBox',
    data() {
        return {
            fileInfo: {},
            dialogFormVisible: false,
            hideBtn: false
        }
    },
    mounted() {
    },
    props: ['uploadType'],
    methods: {
        // 提交
        submit() {
            this.$emit('saveMaterialFile', this.fileInfo)
            this.dialogFormVisible = false
        },
        // 保存文件
        _saveFile(file) {
            if (file.keyid) {
                this.fileInfo = file
                this.hideBtn = false
            } else {
                this.hideBtn = true
            }
        },
        openDialog() {
            this.dialogFormVisible = true
            this.flieList = []
            let _this = this
            this.$nextTick(() => {
                // _this.$refs.scroll.getList((_this.$refs.scroll.$el.offsetWidth - 60) / 100)
                _this.$refs.scroll.getList(10)
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading',
            'user'
        ])
    },
    components: {
        Scroll
    },
    deactivated() {
        this.$destroy()
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
@import "~common/scss/variable";
.scrollBoxDialog {
    .el-dialog__body {
        padding: 20px 0 !important;
    }
    .dialog-footer {
        .el-button--primary {
            margin-left: 20px;
        }
    }
}
</style>